import React from 'react'
import styled from 'styled-components'
import Pagination from '../Pagination'

const Box = styled.div`
    display: flex;

`
const CardWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 20rem;
    padding-right: 2rem;

    position: fixed;
    bottom:0;
    width: 100%;
    height: 80px;
    bottom: 0;
    box-shadow:  0 0 5px #3d3b3ba6;
    background-color: white;
`
const CardText = styled.div`
    margin-right: 1.3rem;

    .textPrimary{
        font-family: "Poppins";
        font-weight: 600;
        color: black;
    }

    p{
        font-size:1rem;
        font-family: "Poppins";
        font-weight: 600;
        height: 5px;
    }
`
const Row = styled.div`
    display: flex;
    align-items: center;

    svg{
        cursor: pointer;
    }


`


const FooterMercadoLivre = ({value}) => {
    
    return (

        <CardWrapper>
            <Pagination/>
            <Box>
            <CardText>
                <p className='textPrimary'>{value}</p>
                <p>quantidade</p>
            </CardText>
            <CardText>
                <Row>
                <div>

                </div>
                <a href='#up'>
                    <svg  width="22" height="28" viewBox="0 0 22 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.50562 10.8147C6.29468 10.6036 6.29468 10.4043 6.50562 10.2167L10.5837 6.13631C10.7712 5.92526 10.9587 5.92526 11.1462 6.13631L15.2244 10.2167C15.4353 10.4043 15.4353 10.6036 15.2244 10.8147L14.9783 11.0609C14.7908 11.2719 14.5916 11.2719 14.3806 11.0609L11.4626 8.10614V21.3322C11.4626 21.6136 11.322 21.7543 11.0408 21.7543H10.6892C10.408 21.7543 10.2673 21.6136 10.2673 21.3322V8.10614L7.34937 11.0609C7.25562 11.1547 7.15015 11.2016 7.03296 11.2016C6.91577 11.2016 6.82202 11.1547 6.75171 11.0609L6.50562 10.8147Z" fill="#A1A1A1" />
                </svg>
                </a>
                </Row>
            </CardText>
            </Box>
        </CardWrapper>

    )
}

export default FooterMercadoLivre